export default "974ac85d02966d2057b2c601f8827491.png";